// SPDX-License-Identifier: BUSL-1.1

/**
 * Full-page loading indicator. Used during auth + org loading.
 *
 */

export function LoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-950">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-neutral-700 border-t-emerald-500" />
    </div>
  );
}
